// Ids of the Kendo windows the PRF pages render. Kept in one place so the Razor views and the
// JavaScript that drives them cannot drift apart.

export const REOPEN_CONFIRMATION_WINDOW_ID = 'prfReopenConfirmWindow';
